import breakpoints from './breakpoints';
import { font, colors } from './constants';
const typography = {
  fontFamily: font.fontFamily,
  fontWeightLight: font.fontWeightLight,
  fontWeightRegular: font.fontWeightRegular,
  fontWeightMedium: font.fontWeightMedium,
  fontWeightBold: font.fontWeightBold,
  htmlFontSize: font.htmlFontSize,
  hero: {
    fontFamily: font.fontFamilyCondensed,
    fontSize: '3rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '5rem'
    }
  },
  banner: {
    fontFamily: font.fontFamilyCondensed,
    fontSize: '2.5rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '3rem'
    }
  },
  h1: {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: 1.3,
    [breakpoints.up('md')]: {
      fontSize: '9rem',
      lineHeight: 1.15
    }
  },
  h2: {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: 1.3,
    [breakpoints.up('md')]: {
      fontSize: '5rem',
      lineHeight: 1.2
    }
  },
  h3: {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: 1.3,
    [breakpoints.up('md')]: {
      fontSize: '4rem',
      lineHeight: 1.2
    }
  },
  h4: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '3rem',
      lineHeight: 1.3
    }
  },
  h5: {
    fontSize: '2rem',
    fontWeight: 'bold',
    lineHeight: 1.5,
    [breakpoints.up('md')]: {
      fontSize: '2.5rem',
      lineHeight: 1.4
    }
  },
  h6: {
    fontSize: '1.7rem',
    fontWeight: 'bold',
    lineHeight: 1.6,
    [breakpoints.up('md')]: {
      fontSize: '2rem',
      lineHeight: 1.5
    }
  },
  subtitle1: {
    fontSize: '1.7rem',
    lineHeight: 1.6
  },
  subtitle2: {
    fontSize: '1.7rem',
    lineHeight: 1.6,
    fontWeight: 'normal',
    color: colors.oriGrey.A400
  },
  body1: {
    fontSize: '1.4rem',
    lineHeight: 1.5,
    fontWeight: 'normal'
  },
  body2: {
    fontSize: '1.4rem',
    lineHeight: 1.5,
    color: colors.oriGrey.A400
  },
  button: {
    fontSize: '1.4rem',
    lineHeight: 1.75,
    fontWeight: 'bold'
  },
  caption: {
    fontSize: '1.2rem',
    lineHeight: 1.5
  },
  overline: {
    fontSize: '1rem',
    lineHeight: 1.5,
    textTransform: 'none'
  }
};
export default typography;
//# sourceMappingURL=typography.js.map